export enum introAssetConfig {
    // introBG = "assets/intro/intro_screen_base.png"
}